import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=2e0a51f1&"
import script from "./UserBox.vue?vue&type=script&lang=ts&"
export * from "./UserBox.vue?vue&type=script&lang=ts&"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=2e0a51f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports